import React from 'react';
import styles from './styles';
import {Form} from '@xpertdox_js/xdcomponents';

const ChildForm = props => {
  const [formState, setFormState] = React.useState(props.value || {})
  const optionsType = Array.isArray(props.options) ? 'array' : typeof props.options;
  const currentValue = formState[props.id];
  let childChain = [];
  if (currentValue && optionsType === 'object') {
    currentValue.forEach((key, i) => {
      childChain.push(<ChildForm
        setRefreshState={props.setRefreshState}
        refreshState={props.refreshState}
        updateChangeState={(value) => props.updateChangeState({
          [props.property]: {
            ...props.changeState[props.property],
            ...value,
          }
        })}
        key={key}
        property={key}
        value={props.value[key]}
        options={props.options[key]}
        id={props.id + '_' + key}
        inner={true}
        even={i % 2 === 1}
      />)
    })
  }


  // no options chosen(means select all options)
  const isEmpty = optionsType === 'array' && props.options.length === 0;

  // track changes to force parent to refresh
  const changeTrack = React.useRef(null);
  // initialize ref after formstate is initialized
  if (changeTrack.current === null && formState[props.id])
    changeTrack.current = formState[props.id];
  // on change update refresh state by 1
  if (changeTrack.current !== null && changeTrack.current !== formState[props.id]) {
    props.setRefreshState(props.refreshState + 1);
    let update = {...props.changeState};
    if (optionsType === 'array') {
      update[props.property] = formState[props.id];
    } else if (optionsType === 'object') {
      formState[props.id].forEach(property => {
        if (update[props.property][property] === undefined) update[props.property][property] = [];
        else update[props.property][property] = update[props.property][property];
      })
      Object.keys(update[props.property]).forEach(property => {
        if (!formState[props.id].includes(property)) delete update[props.property][property];
      })
    }
    props.updateChangeState(update)
    changeTrack.current = formState[props.id];
  }


  return(
    <div style={props.inner
      ? {
          ...styles.container,
          ...styles.innerContainer,
          background: 'rgba(0,0,0,0.02)'
        }
      : styles.container
    }>
      <div style={{...styles.indentLine, top: isEmpty ? '15px' : '18px'}}></div>
      {isEmpty
        ? <p style={styles.staticProperty}><b>{props.property}</b></p>
        : <Form
            state={{formState, setFormState}}
            styles={{
              submit: {display: 'none'},
            }}
            settings={[{
              label: props.property,
              labelStyles: props.inner ? {marginBottom: 0} : {},
              placeholder: 'All',
              type: 'multiselect',
              id: props.id,
              value: Array.isArray(props.value)
                ? props.value.filter(val => val !== 'std_ignore')
                : typeof props.value === 'object'
                ? Object.keys(props.value)
                : null,
              options: optionsType === 'object'
                ? Object.keys(props.options)
                : props.options.filter(val => val !== 'std_ignore'),
              notRequired: true,
            }]}
          />
      }
      {childChain.length > 0 &&
        <div style={props.inner ? {...styles.childContainer, ...styles.innerChildContainer} : styles.childContainer}>
          {childChain}
        </div>
      }
    </div>
  )
}

export default ChildForm;
